/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type useLiveNotificationsPolling_settings = {
    readonly inPageNotifications: {
        readonly enabled: boolean | null;
    } | null;
    readonly " $refType": "useLiveNotificationsPolling_settings";
};
export type useLiveNotificationsPolling_settings$data = useLiveNotificationsPolling_settings;
export type useLiveNotificationsPolling_settings$key = {
    readonly " $data"?: useLiveNotificationsPolling_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"useLiveNotificationsPolling_settings">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useLiveNotificationsPolling_settings",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "InPageNotificationsConfiguration",
            "kind": "LinkedField",
            "name": "inPageNotifications",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "enabled",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any);
(node as any).hash = '111476ba5e69597bf72024203098b384';
export default node;
